var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7982 19.2975C13.8354 17.5046 17.9279 12.6333 17.9279 9.27181C17.9279 7.41191 17.1891 5.62818 15.8739 4.31303C14.5588 2.99788 12.775 2.25903 10.9151 2.25903C9.05522 2.25903 7.27149 2.99788 5.95634 4.31303C4.64119 5.62818 3.90234 7.41191 3.90234 9.27181C3.90234 12.6333 8.09755 17.5046 10.1359 19.2975C10.5077 19.6294 10.4687 19.7131 10.9671 19.7131C11.4654 19.7131 11.4264 19.6294 11.7982 19.2975ZM8.57753 9.27181C8.57753 8.65185 8.82381 8.05727 9.2622 7.61889C9.70058 7.1805 10.2952 6.93422 10.9151 6.93422C11.5351 6.93422 12.1297 7.1805 12.5681 7.61889C13.0064 8.05727 13.2527 8.65185 13.2527 9.27181C13.2527 9.89178 13.0064 10.4864 12.5681 10.9247C12.1297 11.3631 11.5351 11.6094 10.9151 11.6094C10.2952 11.6094 9.70058 11.3631 9.2622 10.9247C8.82381 10.4864 8.57753 9.89178 8.57753 9.27181Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocate);
export default __webpack_public_path__ + "static/media/Locate.8b73bc3f69a7152c72888c821f9c01e8.svg";
export { ForwardRef as ReactComponent };